"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* The templates list (the web Templates dialog, mobile Settings → Templates): one tab per scope (Mine,
 * each of my teams, Org), what a new template in a tab is shared with, and
 * how a deleted template's scope reads. */






// How long "Template deleted. Undo" stays up.
 const UNDO_TOAST_MS = 10000; exports.UNDO_TOAST_MS = UNDO_TOAST_MS

 const templateTabs = (teams) => [
  { value: 'mine', label: 'Mine' },
  ...teams.map(t => ({ value: `team:${t.TeamKey}` , label: t.Name })),
  { value: 'org', label: 'Org' },
]; exports.templateTabs = templateTabs

 const inTemplateTab = (tab) => (t) =>
  tab === 'mine' ? t.Scope === 'private'
    : tab === 'org' ? t.Scope === 'org'
      : t.Scope === 'team' && `team:${t.TeamKey}` === tab; exports.inTemplateTab = inTemplateTab

/* "+ New template" in a tab starts shared with that tab's scope. */
 const newTemplateChoice = (tab) => (tab === 'mine' ? 'private' : tab); exports.newTemplateChoice = newTemplateChoice

/* "Mine", the team's name, or "Org". */
 const templateScopeLabel = (t, teamNames) =>
  t.Scope === 'private' ? 'Mine' : t.Scope === 'org' ? 'Org' : _nullishCoalesce(teamNames[_nullishCoalesce(t.TeamKey, () => ( ''))], () => ( 'Team')); exports.templateScopeLabel = templateScopeLabel

/* The line under the Org tab. */
 const orgTabHint = (orgName) => `Everyone at ${orgName} can use and edit these.`; exports.orgTabHint = orgTabHint
